/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { startProgress, stopProgress } from './progress-util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { postToBackend2 } from './fetch-util.js';
import { mjt } from './i18ntexts.js';

import '../vendor/setImmediate.cjs';


export let MDObject = function($,mj) {
	var m_object_attributes_changed_observers = [],		// each observer is function( object_type, object_id, attributes, item_count )
		m_object_deleted_observers = [],				// each observer is function( object_type, object_id )
		m_object_item_list_changed_observers = [];		// each observer is function( object_type, object_id, item_count )

	var m_object_type_names;

	var m_object_default_item_keys = {
		'lightbox':		'media_id',
		'collection':	'media_id',
	};

	var m_object_type_user_relation_options = {
		'lightbox': {
			'shared': {
				'modify': '',	// modify properties
				'delete': '',	// delete items
				'add': '',		// add items
			},
		},
		'collection': {
			'shared':	{
				'modify': null,	// modify properties
			},
		},
	};

	function init() {
		m_object_type_names = {
			'lightbox':		mjt('md-object-type-lightbox'),
			'collection':	mjt('md-object-type-collection'),
		};
		m_object_type_user_relation_options.collection.shared.modify = mjt('md-object-type-collection-right-modify');	// modify properties
	}

	function getObjectTypeName( type ) {
		return m_object_type_names[type];
	}

	function queryObjectList( type, relation, listfilter, success_cb ) {
		startProgress();
		var data = {
			'type': type,
			'relation': relation,
			'listfilter': listfilter,
		};
		$.postJSON( mj.webroot+'json/object/object-list', data, function(j) {
			stopProgress();
			if(j) success_cb(j);
		});
	}

	function queryObject( type, object_id, success_cb ) {
		startProgress();
		var data = {
			'type': type,
			'object_id': object_id,
		};
		$.postJSON( mj.webroot+'json/object/object-get', data, function(j) {
			stopProgress();
			if( j ) success_cb( j );
		} );
	}

	function queryObjectMediaIDs( type, item_key, object_id, success_cb ) {
		if( item_key===null ) item_key = m_object_default_item_keys[type]||'media_id';
		startProgress();
		var data = {
			'type': type,
			'item_key': item_key,
			'object_id': object_id,
			'filter_deleted': 1,
		};
		$.postJSON( mj.webroot+'json/object/object-getallmids', data, function(j) {
			stopProgress();
			if( j ) success_cb( j[item_key+'s'], j.result_count );
		} );
	}


	function createObject( type, attributes, sort_key, is_public, success_cb ) {
		startProgress();
		var data = {
			'type': type,
			'attributes': JSON.stringify(attributes),
			'is_public': is_public,
		};
		if( sort_key!=null ) data.sort_key = sort_key;
		$.postJSON('json/object/object-create', data, function(j) {
			stopProgress();
			if( j ) success_cb(j);
		});
	}

	function updateObjectProperties( type, object_id, attributes, merge_attributes, sort_key, is_public, success_cb ) {
		startProgress();
		var data = {
			'type': type,
			'object_id': object_id,
			'merge_attributes': merge_attributes,
		};
		if( attributes!=null ) data.attributes = JSON.stringify(attributes);
		if( sort_key!=null ) data.sort_key = sort_key;
		if( is_public!=null ) data.is_public = is_public;

		$.postJSON( mj.webroot+'json/object/object-update', data, function(j) {
			stopProgress();
			if( j )  {
				success_cb( j );
				$.each( m_object_attributes_changed_observers, function(idx,fn) {
					//console.log(['fn(type,id,j.attributes,j.count)',type,object_id,j.attributes,j.count]);
					fn(type,object_id,j.attributes,j.count);
				} );
			}
		});
	}

	function deleteObject( type, object_id, success_cb ) {
		startProgress();
		$.postJSON( mj.webroot+'json/object/object-delete', 'type='+encodeURIComponent(type)+'&object_id='+encodeURIComponent(object_id), function(j) {
			stopProgress();
			success_cb();
			$.each( m_object_deleted_observers, function(idx,fn) {
				//console.log(['fn(type,object_id)',type,id]);
				fn(type,object_id);
			} );
		});
	}

	function createObjectAndRelations( type, attributes, sort_key, is_public, relation_type, relation_items, success_cb ) {
		startProgress();
		var data = {
			'type': type,
			'attributes': JSON.stringify(attributes),
			'is_public': is_public,
			'relation_type': relation_type,
			'relation_items': JSON.stringify(relation_items),
		};
		if( sort_key!=null ) data.sort_key = sort_key;
		$.postJSON('json/object/object-create', data, function(j) {
			stopProgress();
			if( j ) success_cb(j);
		});
	}

	function updateObjectPropertiesAndRelations( type, object_id, attributes, merge_attributes, sort_key, is_public, relation_type, relation_items, success_cb ) {
		startProgress();
		var data = {
			'type': type,
			'object_id': object_id,
			'merge_attributes': merge_attributes,
			'relation_type': relation_type,
			'relation_items': JSON.stringify(relation_items),
		};
		if( attributes!=null ) data.attributes = JSON.stringify(attributes);
		if( sort_key!=null ) data.sort_key = sort_key;
		if( is_public!=null ) data.is_public = is_public;
		$.postJSON( mj.webroot+'json/object/object-update', data, function(j) {
			stopProgress();
			if( j ) {
				success_cb(j);
				$.each( m_object_attributes_changed_observers, function(idx,fn) {
					fn(type,object_id,j.attributes,j.count);
				} );
			}
		});
	}

	function queryObjectItems( type, item_key, object_id, offset, count, meta_ids, success_cb ) {
		if( item_key===null ) item_key = m_object_default_item_keys[type]||'media_id';
		startProgress();
		var data = {
			'type': type,
			'item_key': item_key,
			'object_id': object_id,
			'count': count,
			'offset': offset,
			'meta_ids': meta_ids,
		};
		$.postJSON( mj.webroot+'json/object/object-items', data, function(j) {
			stopProgress();
			if( j ) success_cb(j);
		});
	}

	function insertObjectItems( type, object_id, items, pos, success_cb ) {
		startProgress();
		var data = {
			'type': type,
			'object_id': object_id,
			'items': items,
			'pos': pos,
		};
		$.postJSON( mj.webroot+'json/object/object-items_insert', data, function(j) {
			stopProgress();
			if( j ) {
				success_cb( j );
				$.each( m_object_item_list_changed_observers, function(idx,fn) {
					//console.log(['fn(type,id,j.count)',type,id,j.count]);
					fn(type,object_id,j);
				} );
			}
		});
	}

	function removeObjectItems( type, object_id, items, item_key, success_cb, silent ) {
		if( item_key===null ) item_key = m_object_default_item_keys[type]||'media_id';
		if( !silent ) startProgress();
		var data = {
			'type': type,
			'object_id': object_id,
			'items_list': items,
			'item_key': item_key,
		};
		$.postJSON( mj.webroot+'json/object/object-items_remove', data, function(j) {
			if( j ) {
				success_cb(j);
				if( !silent ) stopProgress();
				$.each( m_object_item_list_changed_observers, function(idx,fn) {
					fn(type,object_id,j);
				} );
			} else {
				if( !silent ) stopProgress();
			}
		});
	}


	function updateObjectRelations( object_id, relation_type, relation_items, success_cb ) {
		startProgress();
		var url = 'object_id='+encodeURIComponent(object_id)+'&relation_type='+encodeURIComponent(relation_type)+'&relation_items='+encodeURIComponent(JSON.stringify(relation_items));
		$.postJSON('json/object/relation-update', url, function(j) {
			stopProgress();
			success_cb();
		});
	}

	function deleteObjectRelation( object_id, relation_type, related_user_id, success_cb ) {
		startProgress();
		var url = 'object_id='+encodeURIComponent(object_id)+'&relation_type='+encodeURIComponent(relation_type)+'&related_user_id='+encodeURIComponent(related_user_id);
		$.postJSON('json/object/relation-delete', url, function(j) {
			stopProgress();
			success_cb();
		});
	}

	function getAvailableObjectRelationOptions( object_type, relation_type ) {
		return Object.getOwnPropertyNames(m_object_type_user_relation_options[object_type][relation_type]);
	}

	function getObjectRelationOptionTranslation( object_type, relation_type, option ) {
		return m_object_type_user_relation_options[object_type][relation_type][option];
	}

	function hasObjectRelation( object_id, relation_type, option_name, success_cb ) {
		startProgress();
		var url = 'object_id='+encodeURIComponent(object_id)+'&relation_type='+encodeURIComponent(relation_type);
		if( option_name!==null ) url += '&option_name='+encodeURIComponent(option_name);
		$.postJSON('json/object/relation-exists', url, function(j) {
			stopProgress();
			if(j) success_cb(j);
		});
	}


	function queryObjectRelationsOLD( type, object_id, relation_type, success_cb ) {
		startProgress();
		var url = 'type='+encodeURIComponent(type)+'&object_id='+encodeURIComponent(object_id)+'&relation_type='+encodeURIComponent(relation_type);
		$.postJSON('json/object/relation-listold', url, function(j) {
			stopProgress();
			if(j) success_cb(j);
		} );
	}

	function queryObjectRelations( type, object_id, relation_type, success_cb ) {
		startProgress();
		var url = 'type='+encodeURIComponent(type)+'&object_id='+encodeURIComponent(object_id)+'&relation_type='+encodeURIComponent(relation_type);
		$.postJSON('json/object/relation-list', url, function(j) {
			stopProgress();
			if(j) success_cb(j);
		} );
	}


	var m_users_available_for_object_sharing_relation = null;
	var m_uafosr_callbacks = [];

	function queryUsersAvailableForObjectSharingRelation( success_cb, error_cb, silent ) {
		if( m_users_available_for_object_sharing_relation!==null ) {
			// use cached data
			window.setImmediate( function() {
				success_cb(m_users_available_for_object_sharing_relation);
			} );
			return;
		}

		m_uafosr_callbacks.push(success_cb);
		if( m_uafosr_callbacks.length>1 ) {
			// another query is already running - but success_cb is queued and will be called when that other one finishes
			return;
		}

		if( !silent ) startProgress();
		postToBackend2(
			'json/widgets/entities-users',
			'', // postdata
			function _success( j, jqXHR ) {
				if( !silent ) stopProgress();
				if( !j ) {
					if( error_cb ) error_cb(j&&j.error?j.error:'unknown error');
					return;
				}

				m_users_available_for_object_sharing_relation = [];
				for( var i=0; i<j.length; ++i ) {
					var user = j[i];
					if( user.id==mj.user_id ) continue; // exclude self
					m_users_available_for_object_sharing_relation.push([user.id,user.title]);
				}

				// run all success callbacks in queue
				while( m_uafosr_callbacks.length ) {
					var first_uafosr_cb = m_uafosr_callbacks.shift();
					if( first_uafosr_cb ) first_uafosr_cb(m_users_available_for_object_sharing_relation);
				}
			},
			function _timeout() {
				// timeout
				if( !silent ) stopProgress();
				if( error_cb ) error_cb('timeout');
			},
			function _error( jqXHR, textStatus, message ) {
				// other error
				if( !silent ) stopProgress();
				if( error_cb ) error_cb(jqXHR.responseJSON && jqXHR.responseJSON.error ? jqXHR.responseJSON.error : jqXHR.status);
			},
			true	// default_handle_errors
			// function _complete( jqXHR, textStatus, self ) {
			// }
		);
	}


	function ObjectResultInfo( state ) {
		// see mjMediaResultViewWidget listChanged
		var defaults = {
			'list_type':	'unknown',
			'list_id':		null,
			'list_count':	null,
		};
		// init result state data
		// -> ensure _state becomes independent object (a deep copy of defaults plus provided state)

		// this._state = Object.assign( {}, defaults, state||{} );
		this._state = $.extend( true, {}, defaults, state||{} );
	}

	ObjectResultInfo.prototype = {
		getType: function() {
			return this._state.list_type;
		},
		getId: function() {
			return this._state.list_id;
		},
		getState: function() {
			return this._state;
		},
		createCopy: function() {
			return new ObjectResultInfo(this._state);
		},
	};

	function createObjectResultInfo( state ) {
		return new ObjectResultInfo(state);
	}

	return {
		init: init,

		getObjectTypeName: getObjectTypeName,

		queryObjectList: queryObjectList,
		queryObject: queryObject,
		queryObjectMediaIDs: queryObjectMediaIDs,
		createObject: createObject,
		updateObjectProperties: updateObjectProperties,
		deleteObject: deleteObject,

		createObjectAndRelations: createObjectAndRelations,
		updateObjectPropertiesAndRelations: updateObjectPropertiesAndRelations,

		queryObjectItems: queryObjectItems,
		insertObjectItems: insertObjectItems,
		removeObjectItems: removeObjectItems,

		queryObjectRelationsOLD: queryObjectRelationsOLD,
		queryObjectRelations: queryObjectRelations,

		queryUsersAvailableForObjectSharingRelation: queryUsersAvailableForObjectSharingRelation,

		getAvailableObjectRelationOptions: getAvailableObjectRelationOptions,
		getObjectRelationOptionTranslation: getObjectRelationOptionTranslation,

		hasObjectRelation: hasObjectRelation,
		updateObjectRelations: updateObjectRelations,
		deleteObjectRelation: deleteObjectRelation,

		bindObjectAttributesChanged: function bindObjectAttributesChanged( fn ) {
			m_object_attributes_changed_observers.push(fn);
		},
		bindObjectDeleted: function bindObjectDeleted( fn ) {
			m_object_deleted_observers.push(fn);
		},
		bindObjectItemListChanged: function bindObjectItemListChanged( fn ) {
			m_object_item_list_changed_observers.push(fn);
		},

		createObjectResultInfo: createObjectResultInfo,
	};

}(jQuery,mj); // namespace MDObject
